import React, { useState } from "react";
import submit from "submit-form";
import WeekDailyStats from "./WeekDailyStats";
import SvgIcon from "../../../../parts/SvgIcon";

const {
  DATE_FORMATS: { DATE_DAY_FORMAT },
} = require("../../../../constants");

function HeadingWeek({ date, query, activeUser, dailyStats }) {
  const [opened, setOpened] = useState(false);
  const dayString = date.clone().format(DATE_DAY_FORMAT);
  return (
    <header>
      <a
        href={`/actions/refresh?view=day&date=${dayString}&start=&end=`}
        className="flex items-center gap-2"
      >
        <p className="s1 clipped">{date.format("MMM D")}</p>
        <p className="s1">{date.format("dddd")}</p>
      </a>

      <hgroup>
        <WeekDailyStats activeUser={activeUser} dailyStats={dailyStats} />
        <details role="list" open={opened}>
          <summary
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpened(!opened);
            }}
            onBlur={(e) => {
              if (!e.relatedTarget || !e.relatedTarget.role === "listbox") {
                e.preventDefault();
                setOpened(false);
              }
            }}
            aria-haspopup="listbox"
            className="!p-0 !h-auto"
          >
            <SvgIcon src="/img/new-icons/vuesax-linear-add-square.svg" />
          </summary>
          <ul role="listbox" className={opened ? "opened" : ""} tabIndex="-1">
            <li
              onClick={(e) => {
                e.stopPropagation();
                setOpened(false);
                submit(`/actions/refresh?`, {
                  method: "GET",
                  body: {
                    "modal[type]": "calendar-add-exercise",
                    day: date.format(DATE_DAY_FORMAT),
                  },
                });
              }}
            >
              <a>Add Exercise</a>
            </li>
            <li
              onClick={(e) => {
                e.stopPropagation();
                setOpened(false);
                submit("/actions/refresh?", {
                  method: "GET",
                  body: {
                    view: "day",
                    date: date.format(DATE_DAY_FORMAT),
                  },
                });
              }}
            >
              <a>View</a>
            </li>
            <li
              onClick={(e) => {
                e.stopPropagation();
                setOpened(false);
                submit("/actions/refresh?", {
                  method: "GET",
                  body: {
                    "modal[type]": "calendar-move-workout",
                    day: date.format(DATE_DAY_FORMAT),
                  },
                });
              }}
            >
              <a>Move</a>
            </li>
            <li
              onClick={(e) => {
                e.stopPropagation();
                setOpened(false);
                submit("/actions/refresh?", {
                  method: "GET",
                  body: {
                    "modal[type]": "calendar-duplicate-workout",
                    day: date.format(DATE_DAY_FORMAT),
                  },
                });
              }}
            >
              <a>Duplicate</a>
            </li>
            <li
              onClick={(e) => {
                e.stopPropagation();
                setOpened(false);
                handleRemove(e, date, query.athlete);
              }}
            >
              <a>Remove</a>
            </li>
          </ul>
        </details>
      </hgroup>
    </header>
  );
}

function handleRemove(e, date, athlete) {
  if (confirm("Are you sure you want to remove this workout?")) {
    e.preventDefault();

    submit(
      `/actions/exercise/unschedule-workout?date=${date.format(
        DATE_DAY_FORMAT
      )}&proxyAthlete=${athlete}`,
      {
        method: "POST",
        body: {
          days: [date.format(DATE_DAY_FORMAT)],
          source: "calendarWeekView",
        },
      }
    );
  }
}

export default HeadingWeek;
